import React from 'react'
import classNames from 'classnames'
import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'
// eslint-disable-next-line no-restricted-imports
import { ReactComponent as PosIntlBg } from '@toasttab/shared/src/assets/svg/other/pos-intl-bg.svg'
import TwoColumnContent from './TwoColumnContent'
import { ColumnsProps } from './Columns.d'

const Columns = ({
  bgColor,
  children = [],
  cssClasses,
  scrollTrackingSectionName,
  sectionDescription,
  sectionHeading,
  hideMobile,
  backgroundImageLgUrl,
  backgroundImageSmUrl,
  hideBackgroundOnMobile,
  useAlternateBackground,
  twoColumnOnTablet,
  textAlignment,
  toggleSwitch = false,
  uniqueId
}: ColumnsProps) => {
  const columnsWrapperClasses = classNames('ds-wrapper', cssClasses, {
    'my-[1.5625rem] [@media(min-width:768px)_and_(max-width:991px)]:py-[1rem] [@media(min-width:992px)]:pb-[2.5rem]':
      !twoColumnOnTablet,
    bgColor: !toggleSwitch
  })
  const textColor = classNames({
    'text-white': bgColor === 'bg-brand-50' || bgColor === 'bg-blue-50',
    'text-default': bgColor !== 'bg-brand-50' && bgColor !== 'bg-blue-50'
  })
  const hideMobileStyle = classNames({
    '[@media(max-width:991px)]:!hidden': hideMobile
  })

  const renderColumns = () => {
    return children.map((column: any, index: number) => {
      return (
        <TwoColumnContent
          columnContents={column.columnContents}
          key={index}
          textColor={textColor}
          twoColumnOnTablet={twoColumnOnTablet}
        />
      )
    })
  }

  let bgImage = ''
  if (!useAlternateBackground) {
    bgImage = backgroundImageLgUrl
      ? "md:bg-[url('https://images.ctfassets.net/tgv5pu8pgmos/2hT5zC0wQvV3P6TezBb94v/9d3524c2ca328a86d387588b64fb903d/header-lineart.svg')]"
      : ''
    bgImage += backgroundImageSmUrl
      ? "[@media(max-width:767px)]:bg-[url('https://images.ctfassets.net/tgv5pu8pgmos/3IYAD6s6oXYijywDtkTrYk/776c1672f2590ddeaccbbe849baf87c8/features-header-lineart-mobile.svg')]"
      : ''
  }
  const headingContainerCss = !twoColumnOnTablet
    ? '[@media(min-width:992px)]:max-w-[50%] [@media(min-width:992px)]:ml-[25%]'
    : 'md:max-w-[80%] md:ml-[10%] pb-6'
  const twoColContainerCss = !twoColumnOnTablet
    ? 'items-center [@media(min-width:992px)]:grid-cols-12 [@media(min-width:768px)_and_(max-width:991px)]:gap-0"'
    : 'items-center md:grid-cols-12'
  const headingCss = twoColumnOnTablet ? 'md:max-w-[80%] md:ml-[10%]' : ''
  const topContainerCss = !twoColumnOnTablet
    ? 'ds-container !max-w-[1236px] mt-10 [@media(min-width:768px)_and_(max-width:991px)]:my-0 [&(:last-child)]:pb-5 [&:not(:last-child)]:pb-[.7rem] [@media(min-width:768px)_and_(max-width:991px)]:[&:not(:last-child)]:py-0'
    : 'ds-container pb-5 md:pb-[78px] [&:last-child]:pb-12'
  const paddingTopCss = !twoColumnOnTablet
    ? 'pt-[65px] md:pt-[92px]'
    : 'pt-[48px] z-10'

  return (
    <div
      className={`${
        toggleSwitch ? bgColor : ''
      } ${hideMobileStyle} ${topContainerCss}`}
    >
      {sectionHeading || sectionDescription ? (
        <div className='flex content-center justify-center relative pt-1 [@media(max-width:992px)]:mb-11'>
          {hideBackgroundOnMobile ? (
            <div className='absolute top-0 left-0 z-0 [@media(max-width:575px)]:hidden'>
              <PosIntlBg />
            </div>
          ) : null}
          <div
            className={`flex-col text-${textAlignment} ${bgImage} ${paddingTopCss} md:bg-cover bg-no-repeat max-w-[1236px]`}
          >
            <div className={headingContainerCss}>
              {sectionHeading ? (
                <Typography
                  allowHtml
                  as='h2'
                  classes={`${textColor} ${headingCss} mb-2 !text-[38px] [@media(min-width:992px)]:!text-[2.8125rem]`}
                  variation='h2'
                >
                  {sectionHeading}
                </Typography>
              ) : null}
              {sectionDescription ? (
                <Typography
                  allowHtml
                  as='p'
                  classes='text-[#666]'
                  variation='default'
                >
                  {sectionDescription}
                </Typography>
              ) : null}
            </div>
          </div>
        </div>
      ) : null}
      <div className={columnsWrapperClasses}>
        <div
          className='ds-container !max-w-[1236px] px-[15px] [@media(min-width:576px)_and_(max-width:767px)]:max-w-[540px]
           [@media(min-width:768px)_and_(max-width:991px)]:max-w-[720px]  [@media(min-width:992px)_and_(max-width:1279px)]:max-w-[960px]
           [@media(min-width:1280px)]:max-w-[1236px]'
        >
          <div
            className={`ds-grid grid-cols-6 gap-10 2xl:gap-20 justify-items-stretch ${twoColContainerCss}`}
          >
            {renderColumns()}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Columns
